import { createRouter } from '@tanstack/react-router';
import type { AppConfig } from '../config';
import { routeTree } from './routes';

export function createAppRouter(config: AppConfig) {
  return createRouter({
    routeTree,
    context: { config },
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
}
